import { render, staticRenderFns } from "./ObtenerMatriz.vue?vue&type=template&id=67c9c981&"
import script from "./ObtenerMatriz.vue?vue&type=script&lang=js&"
export * from "./ObtenerMatriz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports